module.exports = __webpack_public_path__ + "5e8219f572854c6e9cfae27be9506dc8.jpg";